// Guest login feature flag per portal: element_visibility.show_guest_login in
// the portal's main.json. Enabled by default for German portals
// (default__de), disabled for non-German portals (default__en) and for the
// licensee portals Harz and Sauerland. Note: usePortalData merges main.json
// shallowly, so portals with their own element_visibility block must set the
// flag explicitly.
export default function useGuestLoginEnabled (): boolean {
  const { main } = usePortalData()
  return main?.element_visibility?.show_guest_login === true
}
